import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import memoizeOne from 'memoize-one';
import { PZATableRow } from './table-row';
import * as lodash from 'lodash';
import { MaterialTableWithDnd } from 'console/table/drag-drop/drag-drop-table';
const convertToObjectMap = memoizeOne((temps) => {
    return temps.map(([temp_out, temp_work]) => ({ temp_out, temp_work }));
});
const convertToMap = memoizeOne((temps_obj) => temps_obj.map(({ temp_out, temp_work }) => [temp_out, temp_work]));
// const scale_device = get_ui_type() === UI_TYPE.Small ? 0.65 : 1;
export function PZATable(props) {
    const { temps, onChange } = props;
    const [temps_obj, setTempsObj] = React.useState(convertToObjectMap(temps));
    React.useEffect(() => {
        const new_temps_obj = convertToObjectMap(temps);
        if (!lodash.isEqual(new_temps_obj, temps_obj))
            setTempsObj(convertToObjectMap(temps));
    }, [temps]);
    const onChangeTableData = useCallback((new_data) => {
        setTempsObj(new_data);
        onChange(convertToMap(new_data));
    }, [setTempsObj, onChange]);
    function onClickAddButton() {
        const new_temps_obj = [...temps_obj, { temp_out: -20, temp_work: 40 }];
        setTempsObj(new_temps_obj);
        onChange(convertToMap(new_temps_obj));
    }
    return (_jsxs(Accordion, { sx: {
            '&.MuiPaper-root': {
                bgcolor: 'background.paper',
                mt: 1,
            },
            '& .MuiButtonBase-root': {
                color: 'text.primary',
            },
            '& .MuiAccordionDetails-root': {
                p: 0,
            },
            '& .MuiTable-root': {
                tableLayout: 'fixed',
                '& th, td': {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'noWrap',
                    md: {
                        padding: '6px 8px 6px 8px',
                    },
                },
                '& th:last-child, td:last-child': {
                    md: {
                        width: '20%',
                    },
                },
            },
        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMore, {}), children: "\u0422\u0430\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0432\u0438\u0434" }), _jsx(AccordionDetails, { children: _jsx(MaterialTableWithDnd, { tableHeaderProps: {
                        columns_name: ['t° вне дома', 't° теплоносителя'],
                        withRemoveButton: true,
                        withAddButton: true,
                        addButtonClick: onClickAddButton,
                    }, containerProps: {
                        style: {
                            overflowX: 'hidden',
                        },
                    }, tableProps: {
                        size: 'small',
                    }, table_data: temps_obj, onChangeData: onChangeTableData, rowComponentFunction: PZATableRow }) })] }));
}
